<template>
    <div>
        <v-container>
            <v-row style="margin-top:150px">
                <v-col cols="12">
                    <v-container fluid>
                        <v-layout justify-center>
                            <v-flex lg4 md4 sm8 xs12>
                              <!--<div class="layout column align-center">
                                <img alt="Vue Material Admin" src="../../assets/microleap.png" style="width:300px">
                              </div>-->
                                <div v-if="clientLogo" class="layout column align-center">
                                    <img :src="getClientLogoImageUrl()" class="logoStyle" alt="logo"/>
                                </div>
                                <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                                    <v-card>
                                        <v-card-text>

                                            <v-form class="pt-3">
                                                <ValidationProvider rules="required" name="username" v-slot="{ errors, valid, failedRules }">
                                                    <v-text-field append-icon="mdi-account"
                                                                  :label="$t('msg.username_label')" name="username"
                                                                  type="text"
                                                                  autocomplete="new-password"
                                                                  :error-messages="$translatedErrorMessages(failedRules,'username')"
                                                                  :success="valid"
                                                                  id="username" v-model="loginDto.username"
                                                                  v-on:keyup.enter="passes(login)"></v-text-field>
                                                </ValidationProvider>
                                                <ValidationProvider rules="required" name="password" v-slot="{ errors, valid, failedRules }">
                                                    <v-text-field append-icon="mdi-lock"
                                                                  :label="$t('msg.password_label')"
                                                                  name="password"
                                                                  type="password"
                                                                  autocomplete="new-password"
                                                                  :error-messages="$translatedErrorMessages(failedRules,'password')"
                                                                  :success="valid"
                                                                  id="password" v-model="loginDto.password"
                                                                  v-on:keyup.enter="passes(login)"></v-text-field>
                                                </ValidationProvider>
                                                <v-spacer></v-spacer>
                                            </v-form>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-layout justify-center>
                                                <v-btn block :loading="loading" @click="passes(login)" color="#81c342"
                                                       dark>
                                                    {{$t('msg.login_button')}}
                                                </v-btn>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </ValidationObserver>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-col>
            </v-row>
            <v-snackbar v-model="invalidUserCredentials" :timeout="timeout" top center color="error">
                {{ text }}
                <v-btn color="white" text @click="invalidUserCredentials = false">
                    Close
                </v-btn>
            </v-snackbar>
        </v-container>
        <v-footer absolute color="#1c3d50" dark>
            <div class="font-weight-regular">©2020 Global Psytech Sdn. Bhd.</div>
        </v-footer>
    </div>
</template>

<script>
    import {userService,preLoginService} from "../../services"
    import {ValidationProvider, ValidationObserver} from 'vee-validate';

    export default {
        name: 'Login',
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        data() {
            return {
                invalidUserCredentials: false,
                text: 'Invalid username or password',
                timeout: 6000,
                snackbar: false,
                loading: false,
                alignment: 'center',
                dense: false,
                justify: 'center',
                outlined: false,
                width: 400,
                loginDto: {
                    username:'',
                    password:''
                },
                hidePassword: true,
                result: '',
                showResult: false,
                loginModelStatus: false,
                required: '',
                clientLogo: ''
            }
        },
        methods: {
            login: function () {
                this.loading = true
                this.invalidUserCredentials = false
                userService.login(this.loginDto.username, this.loginDto.password)
                    .then(response => {
                        this.loading = false
                        if(response)
                            this.$router.push("dashboard")
                    }).catch(error => {
                    this.loading = false
                    error.showResult = true
                    this.invalidUserCredentials = true
                    this.loading = false
                })
            },
            logoData: function () {
                preLoginService.getLogoData().then(response => {
                    this.clientLogo = response.dataResponse.clientLogo
                    //this.productLogo = response.dataResponse.productLogo
                }).catch(error => {
                    console.log(error)
                })
            },
            getClientLogoImageUrl: function() {
                return process.env.VUE_APP_BACKEND_URL + '/api/media/logo/' + this.clientLogo
            }/*,
            getProductLogoImageUrl: function() {
                return process.env.VUE_APP_BACKEND_URL + '/api/media/logo/' + this.productLogo
            }*/
        },
        created() {
            //this.$cookies.set('gfi-package-SME','')
            //this.$cookies.set('gfi-package-MIKRO','')
            this.logoData()
        }
    }
</script>

<style scoped lang="css">
    #login {
        height: 50%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }

    .logoStyle {
        width: 250px;
        height: 90px;
    }

    .eInsightsLogoStyle {
        width: 250px;
        height: 80px;
    }

    .v-application a {
        color: #000;
        text-decoration: none;
        opacity: .5;
    }

    .v-application a:hover {
        opacity: 1;
        text-decoration: underline;
    }
</style>
